module.exports = __webpack_public_path__ + "statics/img/web.16fd3dfe.jpg";